'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Partials = require('../core/Partials');

exports.default = {
  /* Fix NPEs in apps that were using these methods manually */
  componentWillMount: function componentWillMount() {},
  componentWillUnmount: function componentWillUnmount() {},


  partial: _Partials.partial
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2750/js/mixins/ComponentWithPartials.js
// module id = 590
// module chunks = 171